module.exports = __webpack_public_path__ + "static/media/instagram.54d1b577.png";